const values = [
  {
    icon: "🇫🇷",
    title: "Made in France",
    description: "Conception et impression réalisées en France pour soutenir notre savoir-faire local."
  },
  {
    icon: "🌱", 
    title: "Éco-responsable",
    description: "Papiers certifiés FSC et encres écologiques pour respecter notre planète."
  },
  {
    icon: "🚚",
    title: "Livraison offerte",
    description: "Frais de port gratuits dès 50€ d'achat partout en France métropolitaine."
  },
  {
    icon: "✨",
    title: "Qualité premium",
    description: "Matériaux de haute qualité et finitions soignées pour des souvenirs durables."
  }
]

export default function ValuesSection() {
  return (
    <section className="py-8 lg:py-12 bg-soft-gradient">
      <div className="container mx-auto px-4 lg:px-8">

        {/* Values Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="text-center space-y-4 p-6 rounded-xl bg-card/40 backdrop-blur-sm shadow-card hover:shadow-elegant transition-smooth group"
            >
              {/* Icon */}
              <div className="text-4xl mb-4 group-hover:scale-110 transition-bounce">
                {value.icon}
              </div>
              
              {/* Content */}
              <div className="space-y-2">
                <h3 className="font-display font-semibold text-foreground text-lg">
                  {value.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}